import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-suppliers-list',
  templateUrl: './suppliers-list.component.html'
})
export class SuppliersListComponent implements OnInit {

  @Input() suppliers : any;
  constructor() { } 

  ngOnInit(): void {
  }

}
